module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "acitve-items"
  }, [_c('div', {
    staticClass: "active-items-title-read"
  }, [_c('div', {
    staticClass: "active-item-title"
  }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), _c('div', {
    staticClass: "active-item-desc"
  }, [_vm._v(_vm._s(_vm.row.desc))]), _vm._v(" "), _c('div', {
    staticClass: "active-itme-read"
  }, [_vm._l((_vm.row.cate_list), function(cate, i) {
    return _c('span', {
      key: i
    }, [_vm._v(_vm._s(cate.name))])
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.row.views_count) + "阅读")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "active-item-pics"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.pics_url[0],
      "alt": ""
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ef4a8a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news/NewsItem2.vue
// module id = 1479
// module chunks = 0